import { RoutePath } from "#src/utils/route";
import { WorkflowRoutePath } from "../..";

export const WorkflowTaskRoutePath = WorkflowRoutePath.concat(
  new RoutePath<"taskId">({
    path: "/task/:taskId",
    title: "Workflow Task",
    isHidden: true,
  })
);
